<template>
    <div class="google-map-loader">
        <ContentLeftSideWidgedHolder class="google-map-left-side-widged-holder" v-model="searchOptions"
                                     v-bind:google="google" v-bind:map="map"></ContentLeftSideWidgedHolder>
        <div id="google-map" ref="googleMap"></div>
    </div>
</template>

<script>
    import GoogleMapsApiLoader from 'google-maps-api-loader'
    import {mapSettings, directionsSettings} from "../constants/mapSettings";
    import {mapActions, mapGetters, mapMutations} from "vuex";
    import ContentLeftSideWidgedHolder from "./ContentLeftSideWidgedHolder";
    import GoogleMapsInfoWindow from "./GoogleMapsInfoWindow";
    import Vue from 'vue'

    export default {
        name: "GoogleMapLoader",
        components: {ContentLeftSideWidgedHolder},
        props: {},
        data() {
            return {
                apiKey: process.env.VUE_APP_GOOGLE_API_KEY,
                google: null,
                map: null,
                bounds: null,
                directionsService: null,
                directionsRenderer: null,
                markers: new Map(),
                infoWindow: null,
                userMarker: null,
                locations_internal: null,
                searchOptions: {
                    radius: '1000'
                },
                nearbyplaces: null,
                is_open_result: "Peter",
                iconBase: 'https://maps.google.com/mapfiles/kml/shapes/',
            }
        },
        async mounted() {

            this.google = await GoogleMapsApiLoader({
                apiKey: this.apiKey,
                libraries: ['places'],
            }).catch(this.notify_user());
            this.initDirections();
            this.initMap();
            this.initPlaces();
            this.getCurrentPosition();


        },
        watch: {
            searchOptions: {
                handler() {
                    this.getNearbyPlaces()
                },
                deep: true
            },
        },
        created() {
            this.$store.subscribe((mutation) => {
                if (mutation.type === 'addPlacesLocation') {
                    this.createMarker(mutation.payload);
                    // this.markers.push();
                }
                if (mutation.type === "addPlacesLocations") {
                    this.createMarkers(mutation.payload)
                }
                if (mutation.type === "resetLocations") {
                    for (let value of this.markers.values()) {
                        value.setMap(null)
                    }
                    this.markers.clear();
                }
                if (mutation.type === "setUserLocation") {
                    this.setUserMarker();
                    this.getNearbyPlaces()
                }
                if (mutation.type === "setWinner") {
                    this.setDirection()
                }
                // if (mutation.type === "disableLocationByIndex") {
                //     const _location = this.getLocationByIndex()(mutation.payload);
                //     this._disableLocation(_location.id, _location.active)
                // }
            });
            this.$store.subscribeAction({
                after: (action) => {
                    if (action.type === "disableLocationByIndex") {
                        const _location = this.getLocationByIndex()(action.payload);
                        this._disableLocation(_location.id, false)
                    }
                    if (action.type === "enableLocationByIndex") {
                        const _location = this.getLocationByIndex()(action.payload);
                        this._disableLocation(_location.id, _location.active)
                    }
                    if (action.type === "enableLocation") {
                        const _location = this.getLocation()(action.payload);
                        this._disableLocation(_location.id, _location.active)
                    }
                    if (action.type === "disableLocation") {
                        const _location = this.getLocation()(action.payload);
                        this._disableLocation(_location.id, _location.active)
                    }
                }

            })
            // this.$store.subscribeAction((action => {
            //     after: {
            //
            //     }
            //     if(action.type === "disableLocationByIndex"){
            //         const _location = this.getLocationByIndex()(action.payload);
            //         this._disableLocation(_location.id, _location.active)
            //     }
            // }))
        },
        computed: {
            getMapConfig() {
                return {
                    ...mapSettings,
                    center: this.getUserLocation()
                }
            },
            getDirectionsConfig() {
                return {
                    ...directionsSettings
                }
            }
        },
        methods: {
            ...mapGetters([
                "getUserLocation",
                "allLocations",
                "getWinner",
                "getLocation",
                "getLocationByIndex"
            ]),
            ...mapMutations([
                "setUserLocation",
                "resetLocations",
                "addPlacesLocation",
                "addPlacesLocations",
            ]),
            ...mapActions([
                "disableLocation",
                "enableLocation"
            ]),
            initMap() {
                const mapContainer = this.$refs.googleMap;
                this.map = new this.google.maps.Map(mapContainer, this.getMapConfig);
                this.directionsRenderer.setMap(this.map)
            },
            notify_user() {
                this.$notify({
                    group: 'google-maps-api-notifications',
                    type: 'error',
                    title: 'Google Places API',
                    closeOnClick: 'true',
                    duration: -1,
                    text: "I'm sorry, but the rate-limit is exceeded. Please try again tomorrow. The Google-api is expensive...",
                });
            },
            initPlaces() {
                this.setUserMarker();
                this.nearbyplaces = new this.google.maps.places.PlacesService(this.map);

            },
            initDirections() {
                this.directionsService = new this.google.maps.DirectionsService();
                this.directionsRenderer = new this.google.maps.DirectionsRenderer(this.getDirectionsConfig);
            },
            getNearbyPlaces() {
                const request = {
                    location: this.getUserLocation(),
                    radius: this.searchOptions.radius,
                    type: ['restaurant']
                };
                try {
                    this.nearbyplaces.nearbySearch(request, this.get_locations)
                } catch (e) {
                    this.notify_user()
                }
            },
            _disableLocation(id, active = true) {
                active ? this.markers.get(id).setOpacity(1) : this.markers.get(id).setOpacity(0.5);
            },
            setUserMarker() {
                if (this.userMarker) {
                    this.userMarker.setMap(null);
                }
                this.userMarker = new this.google.maps.Marker({
                    map: this.map,
                    animation: this.google.maps.Animation.DROP,
                    position: this.getUserLocation()
                })
            },
            get_locations(result, status) {
                if (status === this.google.maps.places.PlacesServiceStatus.OK) {
                    this.resetLocations();
                    this.addPlacesLocations(result)
                } else {
                    this.notify_user()
                }
            },
            setLocation(pos) {
                this.setUserLocation(pos);
                this.map.setCenter(pos);
            },
            getCurrentPosition() {
                const getUserLocation = this.getUserLocation;
                const setLocation = this.setLocation;
                const handleLocationError = this.handleLocationError;
                if (navigator.geolocation) {
                    navigator.geolocation.getCurrentPosition(function (position) {
                            const pos = {
                                lat: position.coords.latitude,
                                lng: position.coords.longitude
                            };
                            setLocation(pos);
                        }, function (e) {
                            setLocation(getUserLocation());
                            handleLocationError(e);
                        },
                        {
                            enableHighAccuracy: true,
                            timeout: 5000,
                            maximumAge: 60000,
                        });
                } else {
                    setLocation(getUserLocation());
                    // Browser doesn't support Geolocation
                    this.handleLocationError();
                }
            },
            handleLocationError() {
                this.$notify({
                    group: 'google-maps-api-notifications',
                    type: 'warn',
                    title: 'Position not found',
                    closeOnClick: 'true',
                    duration: -1,
                    text: "Please enable your GPS position feature.",
                });
            },
            changeActive(place) {
                const _place = this.getLocation()(place);
                const okay = _place.active;
                _place.active ? this.$store.dispatch("disableLocation", place)
                    : this.$store.dispatch("enableLocation", place);
                if (okay === _place.active) {
                    this.$notify({
                        group: 'google-maps-api-notifications',
                        type: 'info',
                        title: 'Restaurant is not open',
                        closeOnClick: 'true',
                        duration: 5000,
                        text: "Pls try again another time",
                    })
                }
            },
            _createMarker(place) {
                const changeActive = this.changeActive;
                const image = {
                    url: place.icon,
                    size: new this.google.maps.Size(71, 71),
                    origin: new this.google.maps.Point(0, 0),
                    anchor: new this.google.maps.Point(17, 34),
                    scaledSize: new this.google.maps.Size(25, 25)
                };

                var marker = new this.google.maps.Marker({
                    map: this.map,
                    icon: image,
                    animation: this.google.maps.Animation.DROP,
                    title: place.name,
                    position: place.geometry.location
                });
                marker.addListener('click', function () {
                    changeActive(place)
                });
                this.markers.set(place.id, marker);
                if (place.opening_hours && place.opening_hours.open_now !== undefined) {
                    this._disableLocation(place.id, place.opening_hours.open_now);
                }

                return place.geometry.location
            },
            createMarker(place) {
                const bounds = new this.google.maps.LatLngBounds();
                bounds.extend(this._createMarker(place));
            },
            createMarkers(places) {
                const bounds = new this.google.maps.LatLngBounds();
                bounds.extend(this.getUserLocation());
                places.forEach(place => {
                    bounds.extend(this._createMarker(place));
                });
                this.map.fitBounds(bounds);
                this.bounds = bounds;
            },
            setDirection() {
                if (!this.getWinner()) {
                    throw "There are no restaurants to chose a winner from!"
                }
                if (!this.getWinner().geometry) {
                    this.createInfoWindow(this.getWinner());
                    return;
                }
                const directionsRenderer = this.directionsRenderer;
                const start = this.getUserLocation();
                const end = this.getWinner().geometry.location;
                const createInfoWindow = this.createInfoWindow;
                const getWinner = this.getWinner;
                const request = {
                    origin: start,
                    destination: end,
                    travelMode: 'WALKING'
                };
                this.directionsService.route(request, function (result, status) {
                    if (status === "OK") {
                        directionsRenderer.setDirections(result);
                        createInfoWindow(getWinner(), result)
                    } else {
                        createInfoWindow(getWinner());
                    }
                });

            },
            createInfoWindow(location, path) {
                if (this.infoWindow !== null) {
                    this.infoWindow.close()
                }
                const newGoogleMapsInfoWindow = Vue.extend(GoogleMapsInfoWindow);
                const resetMap = this.resetMap;

                const instance = new newGoogleMapsInfoWindow({
                    propsData: {
                        loca: location
                    }
                });
                instance.$mount();
                var infowindow = new this.google.maps.InfoWindow({
                    content: instance.$el
                });
                if (path) {
                    const step = path.routes[0].legs[0].steps.length - 1;
                    infowindow.setPosition(path.routes[0].legs[0].steps[step].end_location);
                } else {
                    infowindow.setPosition(this.getUserLocation())
                }
                infowindow.open(this.map);
                this.google.maps.event.addListener(infowindow,'closeclick',function(){
                    resetMap();
                });
                this.infoWindow = infowindow;
            },
            resetMap(){
                this.directionsRenderer.set('directions', null);
                this.map.fitBounds(this.bounds);
            },
            googleMapsCustomError() {
                alert('Google Maps custom error triggered');
            }
        },
    }
</script>

<style scoped>

    .google-map-loader {
        height: 100%;
        width: 100%;
        padding: 0;
        margin: 0;
    }

    #google-map {
        height: 100%;
        width: 100%;
    }

    @media screen and (min-width: 640px) {
        .google-map-left-side-widged-holder {
        }
    }
</style>